import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Material } from '../material'
import {
  DataContextBuilder,
  ElderBasicPaneLayoutComponent,
  ElderDataToolbarComponent,
  ElderPaneComponent,
  ElderSearchBoxComponent,
  ElderSearchContextDirective,
  ElderSearchInputDirective,
  ElderSearchPanelComponent,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderToolbarContentDirective,
  IDataContext,
  Sort,
} from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { MaterialService } from '../material.service'
import { Router } from '@angular/router'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MatTooltip } from '@angular/material/tooltip'
import { MatIcon } from '@angular/material/icon'
import { DatePipe } from '@angular/common'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { FormsModule } from '@angular/forms'
import { MatInput } from '@angular/material/input'
import { MatFormField } from '@angular/material/form-field'
import { MatSort, MatSortHeader } from '@angular/material/sort'

@Component({
  selector: 'app-material-browser',
  templateUrl: './material-browser.component.html',
  styleUrls: ['./material-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    ElderToolbarContentDirective,
    ElderSearchBoxComponent,
    ElderSearchContextDirective,
    ElderSearchPanelComponent,
    MatFormField,
    MatInput,
    FormsModule,
    ElderSearchInputDirective,
    MatSlideToggle,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatIcon,
    MatTooltip,
    DatePipe,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class MaterialBrowserComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<Material>
  private materialService = inject(MaterialService)
  private router = inject(Router)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.data = DataContextBuilder.start<Material>()
      .pageSize(30)
      .reloadOnLocalChanges()
      .autoStartAsap([new Sort('id', 'asc')])
      .build(this.materialService)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openDetail(material: Material): void {
    this.router.navigate([{ outlets: { side: ['materials', material.id] } }], {
      preserveFragment: true,
    })
  }
}
